import { render, staticRenderFns } from "./PrizeManage.vue?vue&type=template&id=6a93c538&scoped=true"
import script from "./PrizeManage.vue?vue&type=script&lang=js"
export * from "./PrizeManage.vue?vue&type=script&lang=js"
import style0 from "./PrizeManage.vue?vue&type=style&index=0&id=6a93c538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a93c538",
  null
  
)

export default component.exports